<template>
  <div class="minwidth w100 mw100" style="background-color: #151419;color: #fff;">
    <tabbar></tabbar>

    <div class="positionrel w100">
      <img style="width: 100%;height: auto;-webkit-filter: contrast(90%);filter: contrast(90%);"
        :src="require('../../public/img/news/news_banner.png')" />
    </div>

    <div class="pcScreen">
      <div v-if="num == 0" style="width: 60%;margin: 0 auto;padding-bottom: 3%;font-size: max(12px,1.2vw);" :style="">
        <div
          style="width: 100%;font-size: max(25px,2.5vw);border-bottom: 0.05em solid #ebecea;line-height: 2.5;margin-top: 3%;">
          2024年软件业十大趋势前瞻
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;margin-top: 3%;">
          原文：<a
            href="https://www.msn.cn/zh-cn/news/other/2024%E5%B9%B4%E8%BD%AF%E4%BB%B6%E4%B8%9A%E5%8D%81%E5%A4%A7%E8%B6%8B%E5%8A%BF%E5%89%8D%E7%9E%BB/ar-AA1vfcd4?ocid=BingNewsLanding&cvid=af5d2ffa729e460fee48b5b67184405a&ei=11#">2024年软件业十大趋势前瞻</a>
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          2024年软件开发10大趋势：无代码/低代码兴起、AI/ML进化、AR/VR融合、IoT扩展、网络安全升级、云原生/微服务、边缘计算崛起、即时应用增多、开源软件繁荣、绿色编码受重视。
        </div>
        <div style="width: 100%;text-align: center;margin-top: 2%;">
          <img style="width: 100%;" :src="require('../../public/img/news/image1.png')" alt="">
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          人工智能（AI）和机器学习（ML）在软件开发中的应用正变得越来越普遍。它们不再仅仅局限于高级技术公司，几乎每个行业的企业都在利用这些技术提高效率和推动创新。2024年，将出现更多智能应用程序，这些程序能够自动进行数据分析和决策，从而减少人为错误并提高生产力。开发人员可以利用更精细、更复杂的算法以创建更智能的用户体验，例如个性化推荐系统和自动化客户服务。
        </div>
        <div style="width: 100%;text-align: center;margin-top: 2%;">
          <img style="width: 100%;" :src="require('../../public/img/news/image2.png')" alt="">
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          无代码和低代码平台的普及让非技术人员也能参与软件开发。这些平台通过直观的界面和可视化工具，简化了应用程序开发流程。2024年，随着这些平台的不断优化，预计它们将推动市场上快速增长的应用需求，尤其是中小型企业和初创公司，它们将能够以更小的成本和更短的时间推出创新产品。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          以Zoho
          Creator低代码平台为例，它具有快速开发、强大定制、无缝集成、多平台支持以及灵活定价等优势。企业可以利用低代码平台的可视化界面和拖放操作，快速搭建应用程序的框架，然后根据具体需求进行定制和扩展，大大提高开发效率，降低开发成本。同时，Zoho
          Creator还内置了60+标准应用模板，覆盖：OA协同办公、ERP进销存、CRM客户管理、人事绩效财务、企业服务、个人及组织等多个应用场景。无需安装，点击注册，即可在线免费试用。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          增强现实（AR）和虚拟现实（VR）技术正在逐渐从游戏行业扩展到教育、医疗和房地产等多个领域。2024年，通过AR和VR技术，开发人员可以创建更为沉浸的用户体验。这种体验将使得消费者互动变得比以往任何时候都更加真实和生动。该技术的挑战在于优化性能，确保在所有设备上的良好运行，因此对开发技能的要求也在逐步提升。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          物联网（IoT）的应用正在爆炸式增长，预计2024年将进一步扩大到智能家居、智能办公甚至智能城市建设领域。开发人员需要关注如何集成和安全管理大量从连接设备中获取的数据。随着5G网络的普及，物联网设备之间的连接速度和可靠性将得到显著提升，这也会为IoT发展带来更广阔的前景。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          随着数字化转型的深入，网络安全的重要性日益凸显。2024年，确保应用程序和数据的安全性将成为软件开发的首要任务。零信任架构（Zero
          Trust）正在成为一个新的安全框架，不再假设企业内外的网络是安全的，而是以更加细致的方式来保护数据和用户。这将激励安全方案的创新，从而帮助开发人员创建更为安全的应用程序。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          随着企业继续迁移到云端，云原生应用开发和微服务架构的转变对于提升软件项目的灵活性和可扩展性至关重要。2024年，开发人员将受到鼓励去构建能够跨多个云平台无缝运行的应用程序。这种方法通过将应用程序分解成更小、更可管理的模块，使其能更容易地更新和扩展，使业务能够快速响应市场变化。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          边缘计算通过将计算资源移到数据产生地附近，减少了数据的传输延迟，改善了应用程序性能。2024年，随着智能设备的激增和物联网的扩展，边缘计算的使用将变得更加广泛。开发者需要考虑如何高效地分配和管理边缘设备的资源，并确保数据的安全性。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          即时应用技术是指用户可以在无需下载和安装的情况下体验应用功能。从长远看，这种技术提高了用户的访问速度和体验满意度。2024年，更多的企业将开发即时应用，以增强用户体验和提高商业模式的灵活性，因此开发人员需要适应这种新兴的应用开发逻辑。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          开源软件在开发社区的流行并未减少，反而会继续增长。2024年，更多企业和开发者将加入开源项目的贡献行列，并将其作为促进创新和社区协作的关键因素。随着更多组织拥抱开源技术，企业对开发人员在开源项目参与度方面的期望也在增大，尤其是为了提升代码质量和安全性。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          随着环境问题的日益严重，绿色编码正受到越来越多的关注。软件开发者需要制定策略以减少其应用程序的碳足迹，优化代码和算法，以提高能源效率。2024年，绿色编码实践将成为主流，特别是在科技公司和追求可持续性发展的企业中。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          这些趋势不仅代表了技术的变化，更反映了整个软件开发行业对效率、创新和安全的日益重视。紧跟这些趋势，将有助于开发人员和企业在2024年及进一步未来中保持竞争力和创新力。
        </div>
      </div>


      <div v-if="num == 1" style="width: 60%;margin: 0 auto;padding-bottom: 3%;font-size: max(12px,1.2vw);">
        <div
          style="width: 100%;font-size: max(25px,2.5vw);border-bottom: 0.05em solid #ebecea;line-height: 2.5;margin-top: 3%;">
          马斯克大胆预测：2027年AI智力将反超人类
        </div>
        <!-- <div style="text-indent: 2em;line-height: 2;text-align: justify;margin-top: 3%;">
        原文：<a href="https://www.msn.cn/zh-cn/news/other/2024%E5%B9%B4%E8%BD%AF%E4%BB%B6%E4%B8%9A%E5%8D%81%E5%A4%A7%E8%B6%8B%E5%8A%BF%E5%89%8D%E7%9E%BB/ar-AA1vfcd4?ocid=BingNewsLanding&cvid=af5d2ffa729e460fee48b5b67184405a&ei=11#">2024年软件业十大趋势前瞻</a>
      </div> -->
        <div style="text-indent: 2em;line-height: 2;text-align: justify;margin-top: 3%;">
          埃隆·马斯克最近在社交媒体上发表了关于人工智能(AI)未来的大胆预言。马斯克指出，AI正以惊人的速度发展，而人类对这一变革的认知却显得相对迟缓。他大胆预言，在2025年底之前，AI的智力水平将超越任何单独的人类个体。到了2027年至2028年间，AI的整体智力或将凌驾于全人类之上。
        </div>
        <div style="width: 100%;text-align: center;margin-top: 2%;">
          <img style="width: 100%;" :src="require('../../public/img/news/image4.png')" alt="">
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          马斯克还强调，随着时间的推移，AI超越所有人类智力的趋势将愈发明显。他预计，到2030年，这一概率将逼近100%，标志着AI智力全面超越人类的新时代的到来。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          自chatGPT横空出世以来，全球资本对人工智能领域的热情空前高涨。据CB Insights数据显示，去年风投资本在人工智能初创公司上投入了高达425亿美元，涉及2500笔融资，彰显了资本对AI未来的坚定看好。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          然而，面对这一热潮，DeepMind的联合创始人兼CEO哈萨比斯(Demis Hassabis)却发出了警示。他认为，当前人工智能行业正呈现出类似于虚拟货币市场的泡沫迹象。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          尽管哈萨比斯同样认为通用人工智能(AGI)可能在未来十年内成为现实，但在此之前，仍需在一两个关键领域取得突破性进展。因此，他呼吁业界以更为科学、稳健的方法来推动AGI的构建与发展。
        </div>
      </div>


      <div v-if="num == 2" style="width: 60%;margin: 0 auto;padding-bottom: 3%;font-size: max(12px,1.2vw);">
        <div
          style="width: 100%;font-size: max(25px,2.5vw);border-bottom: 0.05em solid #ebecea;line-height: 2.5;margin-top: 3%;">
          “云+AI”赋能千行百业数智化转型升级
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;margin-top: 3%;">
          原文：<a
            href="https://www.msn.cn/zh-cn/news/other/%E4%BA%91-ai-%E8%B5%8B%E8%83%BD%E5%8D%83%E8%A1%8C%E7%99%BE%E4%B8%9A%E6%95%B0%E6%99%BA%E5%8C%96%E8%BD%AC%E5%9E%8B%E5%8D%87%E7%BA%A7/ar-AA1wxTQO?ocid=BingNewsLanding&cvid=af5d2ffa729e460fee48b5b67184405a&ei=25">“云+AI”赋能千行百业数智化转型升级</a>
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          在数字化时代，市场对云的需求进入到深度用云的阶段。尤其是伴随着人工智能的飞速发展，上云场景越来越复杂，需求越来越多样化，大量应用场景需要各专业协同去落地，共建生态是各行各业的诉求。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          12月18日，“全栈可信 云中生智”曙光云战略发布会召开。曙光云从首创“城市云”进化到实现“全栈智能云”，打造“云算、云数、云安、云智”四位一体能力体系，深度赋能千行百业数智化转型升级。
        </div>
        <div style="width: 100%;text-align: center;margin-top: 2%;">
          <img style="width: 95%;" :src="require('../../public/img/news/image5.png')" alt="">
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          曙光云副总裁孙会首表示，智能化是一个多维度的概念，站在不同的角度理解会有所不同。从供给侧来看，智能化意味着提供先进的技术解决方案，如选用合适的算力、构建大模型算法等。而作为运营方，曙光云不仅要提供技术平台，还要将智能化能力嵌入到客户的业务流程中，解决实际问题，提升业务效率。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          据悉，曙光云推出“多元算力融合底座”，提供多芯片算力服务，在通用云计算服务的基础上融合了更多人工智能计算的能力，全方位降低应用开发和应用智能化改造的难度。数据时代，数据来源愈加丰富，数据体量飞速增加，数据类型更加复杂多样，面对这些的挑战，曙光云推出全新升级的“轩辕可信数据平台”，具备数据全生命周期管理能力，打造安全的数据生产流水线，让数据可用不可见。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          曙光云总裁助理曾宇航介绍了曙光云提出的行业智能体架构：“这是一个综合解决方案，通过四位一体能力体系，实现端、边、云、用、数、模的融合，降低应用开发和智能化改造难度，深度赋能千行百业数字化转型。以煤炭矿山行业为例，曙光云通过构建三元融合算力体系，打通数据全链路，实现智能矿山的信息链打通，提升生产效率和安全性，展示了提供定制化智能解决方案的能力，推动行业的数智化转型。”
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          记者获悉，曙光云还聚焦能源、交通、政务等重点行业，提供更加精准和高效的智能化解决方案。在能源领域，曙光云将助力企业实现绿色、低碳、高效的运营。在交通领域，曙光云将推动智能交通系统的建设，提高交通管理的智能化水平。在政务领域，曙光云将助力政府提升治理效能和服务水平，打造智慧政务。
        </div>
      </div>

      <div v-if="num == 3" style="width: 60%;margin: 0 auto;padding-bottom: 3%;font-size: max(12px,1.2vw);">
        <div
          style="width: 100%;font-size: max(25px,2.5vw);border-bottom: 0.05em solid #ebecea;line-height: 2.5;margin-top: 3%;">
          Anthropic：2025年AI进化更剧烈，运算成本激增
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;margin-top: 3%;">
          原文：<a
            href="https://www.msn.cn/zh-cn/news/other/anthropic-2025%E5%B9%B4ai%E8%BF%9B%E5%8C%96%E6%9B%B4%E5%89%A7%E7%83%88-%E8%BF%90%E7%AE%97%E6%88%90%E6%9C%AC%E6%BF%80%E5%A2%9E/ar-AA1wvUk4?ocid=BingNewsLanding&cvid=f00331f237344ec8886a7bbfa81077d9&ei=11">Anthropic：2025年AI进化更剧烈，运算成本激增</a>
        </div>
        <div style="width: 100%;text-align: center;margin-top: 2%;">
          <img style="width: 95%;" :src="require('../../public/img/news/image6.png')" alt="">
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          背后有Google撑腰的AI创业公司商Anthropic共同创办人Jack Clark相信，OpenAI最近成功推出AI模型“o3”，暗示AI发展并未变慢，速度反倒加快了。不过，他警告，最新AI系统的运算成本是重大挑战。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          The Decoder 25日报道，Clark在自己的新闻报《Import
          AI》指出，“每个告诉你AI进展正在趋缓、扩张速度遇阻的人都错了”，OpenAI新推的o3模型就是增长还有空间的证据，但主要是得另辟蹊径。OpenAI并非单纯依靠规模更大的参数，而是让o3在执行时结合强化学习（reinforcement
          learning）技术，并导入额外算力。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          Clark指出，这种边思考边执行的方式，为拓展AI能力打开了全新可能性。他预测该趋势将于2025年加温，届时企业会开始在训练及推论过程中，将传统做法（例如参数更多的基础模型）结合全新的算力运用方式。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          Clark相信，AI演进速度太剧烈，许多人对此完全没准备。运算成本是重大挑战。o3最先进版本需要的算力，是基础版的170倍，而o3基础版使用的资源已比o1多，o1本身需要的算力也高于GPT-4o。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          Clark解释，这些最新系统让成本变得更加难以估算。在过去，成本主要是看模型的参数规模及输出长度，相当简单明了。然而，o3需要的资源却因任务的不同而有天壤之别。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          即便面临上述挑战，Clark依旧相信，把传统拓展方法跟新颖技术结合，将使AI在2025年更加急剧地演进，比至今为止的速度都还要快。
        </div>
      </div>

      <div v-if="num == 4" style="width: 60%;margin: 0 auto;padding-bottom: 3%;font-size: max(12px,1.2vw);">
        <div
          style="width: 100%;font-size: max(25px,2.5vw);border-bottom: 0.05em solid #ebecea;line-height: 2.5;margin-top: 3%;">
          不再“困”于宣传片，机器人从科幻走向现实
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;margin-top: 3%;">
          原文：<a
            href="https://www.msn.cn/zh-cn/news/other/%E4%B8%8D%E5%86%8D-%E5%9B%B0-%E4%BA%8E%E5%AE%A3%E4%BC%A0%E7%89%87%E9%87%8C-%E4%BA%BA%E5%BD%A2%E6%9C%BA%E5%99%A8%E4%BA%BA%E4%BB%8E%E7%A7%91%E5%B9%BB%E8%B5%B0%E5%90%91%E7%8E%B0%E5%AE%9E/ar-AA1wvWB1?ocid=BingNewsLanding&cvid=f00331f237344ec8886a7bbfa81077d9&ei=18">不再“困”于宣传片里，人形机器人从科幻走向现实</a>
        </div>
        <div style="width: 100%;text-align: center;margin-top: 2%;">
          <img style="width: 95%;" :src="require('../../public/img/news/image7.png')" alt="">
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          随着人工智能的跨越式发展，2024年，人形机器人逐渐从科幻走向现实，成为科技界的新热点。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          科技巨头纷纷布局、初创公司相继涌现、供应链不断完善、技术层层迭代……人形机器人作为人工智能领域最具代表性的实体，在大模型的催化下，正加速从实验室走向生产线，实现产业化落地。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          与2023年相比，今年的人形机器人市场，已经不再相信酷炫的宣传片和科技幻想故事，人形机器人的成本能降到多低？他们能用在哪里？成为市场最关切的话题。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          日前，美国《时代周刊》发表了封面文章，汇集并筛选了200项“2024年最佳发明”，其中，人形机器人登上封面，被称为2024年最伟大发明之一。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          目前，人形机器人一般可分为“本体”“小脑”和“大脑”三个部分。其中，“本体”是人形机器人的躯干和四肢；“大脑”承担类似人类大脑认知、推理和决策功能的功能，AI大模型的出现，让人形机器人能够更“聪明”地处理多模态的信息；“小脑”则负责运动控制与协调。相比其他机器人，人形机器人对智能感知、运动控制、智能决策、人机交互等综合能力要求更高。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          过去一年，英伟达、OpenAI、微软、特斯拉等国际领先科技巨头纷纷加码人形机器人赛道。与此前不同的是，人形机器人的发展不再局限于技术的突破，而是更加积极地探索商业化落地场景。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          日前，特斯拉发布了人形机器人Optimus-Gen2的最新视频。视频中，Optimus稳稳地接住了迎面抛来的网球并放下，反应速度与手部灵活度都有所提升。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          早在今年5月，特斯拉研发的二代Optimus人形机器人便已进厂实训，计划2025年底之前开始量产销售。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          11月6日，小鹏汽车发布了全新AI人形机器人Iron。据悉，Iron已经在小鹏的广州工厂初步实践，即将发布和交付的小鹏P7+部分生产岗位已由机器人操作。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          12月16日，上海智元新创技术有限公司（下称“智元机器人”）宣布，公司已开启通用机器人商用量产。据悉，智元机器人通用机器人年度计划产量为962台。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          在此之前，傅利叶、宇树科技、北京中科慧灵、四川天链机器人、魔法原子等企业也都宣布了有关机器人量产的消息。据悉，截至今年10月，傅利叶旗下通用人形机器人GR-1已量产交付超过100台。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          值得一提的是，今年以来，国内人形机器人赛道也备受资本关注。美团先后投资了银河通用、宇树科技；阿里巴巴也投资了逐际动力和星动纪元。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          据高工机器人产业研究所（GGII）不完全统计，今年1月份至10月份，全球人形机器人共发生69起融资事件，总金额超过110亿元。其中，有56起发生在国内，总金额超过50亿元。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          日前，初创企业开普勒机器人提及计划将人形机器人计划将价格控制约为2万—3万美元（折合人民币14万—21万元）左右。智元机器人预测，未来其首款人形机器人远征A1的制造成本将会被控制在20万元以内。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          “目前，人形机器人的商业化落地取得了一定成果，但距离大规模普及仍有距离。”在中国民协新质生产力委员会秘书长吴高斌看来，特斯拉、腾讯等企业已推出人形机器人产品，但成本高昂、技术成熟度不足等问题仍然存在。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          吴高斌认为，想要打通人形机器人商业化的“最后一公里”，关键在于通过技术创新和产业链整合，降低人形机器人的生产成本，使其更加亲民。同时，不断优化算法、传感器等关键技术，提高人形机器人的稳定性和可靠性。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          成本管控机制的完善，将大大降低终端售价，为大规模量产铺平道路。”支培元认为，2025年，人形机器人领域将迎来一系列重大突破。新材料的应用将进一步增强机械结构的灵活性与耐用性，推进人机界面的无缝衔接，使机器人更贴近人类行为模式。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          “虽然确切时间表难以确定，但基于当前发展趋势，人形机器人渐趋平民化已成为不可逆转的趋势。预计在未来五至十年内，随着技术的日臻成熟与市场接受度的不断提高，个人及家庭拥有人形机器人的可能性将显著增加，进而带动社会生活方式的深刻变革。”支培元说。
        </div>
      </div>
    </div>

    <div class="mobileScreen">
      <div v-if="num == 0" style="width: 90%;margin: 0 auto;padding-bottom: 3%;font-size: 2.4vw;" :style="">
        <div
          style="width: 100%;font-size: 5vw;border-bottom: 0.05em solid #ebecea;line-height: 1.5;margin-top: 3%;">
          2024年软件业十大趋势前瞻
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;margin-top: 3%;">
          原文：<a
            href="https://www.msn.cn/zh-cn/news/other/2024%E5%B9%B4%E8%BD%AF%E4%BB%B6%E4%B8%9A%E5%8D%81%E5%A4%A7%E8%B6%8B%E5%8A%BF%E5%89%8D%E7%9E%BB/ar-AA1vfcd4?ocid=BingNewsLanding&cvid=af5d2ffa729e460fee48b5b67184405a&ei=11#">2024年软件业十大趋势前瞻</a>
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          2024年软件开发10大趋势：无代码/低代码兴起、AI/ML进化、AR/VR融合、IoT扩展、网络安全升级、云原生/微服务、边缘计算崛起、即时应用增多、开源软件繁荣、绿色编码受重视。
        </div>
        <div style="width: 100%;text-align: center;margin-top: 2%;">
          <img style="width: 100%;" :src="require('../../public/img/news/image1.png')" alt="">
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          人工智能（AI）和机器学习（ML）在软件开发中的应用正变得越来越普遍。它们不再仅仅局限于高级技术公司，几乎每个行业的企业都在利用这些技术提高效率和推动创新。2024年，将出现更多智能应用程序，这些程序能够自动进行数据分析和决策，从而减少人为错误并提高生产力。开发人员可以利用更精细、更复杂的算法以创建更智能的用户体验，例如个性化推荐系统和自动化客户服务。
        </div>
        <div style="width: 100%;text-align: center;margin-top: 2%;">
          <img style="width: 100%;" :src="require('../../public/img/news/image2.png')" alt="">
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          无代码和低代码平台的普及让非技术人员也能参与软件开发。这些平台通过直观的界面和可视化工具，简化了应用程序开发流程。2024年，随着这些平台的不断优化，预计它们将推动市场上快速增长的应用需求，尤其是中小型企业和初创公司，它们将能够以更小的成本和更短的时间推出创新产品。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          以Zoho
          Creator低代码平台为例，它具有快速开发、强大定制、无缝集成、多平台支持以及灵活定价等优势。企业可以利用低代码平台的可视化界面和拖放操作，快速搭建应用程序的框架，然后根据具体需求进行定制和扩展，大大提高开发效率，降低开发成本。同时，Zoho
          Creator还内置了60+标准应用模板，覆盖：OA协同办公、ERP进销存、CRM客户管理、人事绩效财务、企业服务、个人及组织等多个应用场景。无需安装，点击注册，即可在线免费试用。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          增强现实（AR）和虚拟现实（VR）技术正在逐渐从游戏行业扩展到教育、医疗和房地产等多个领域。2024年，通过AR和VR技术，开发人员可以创建更为沉浸的用户体验。这种体验将使得消费者互动变得比以往任何时候都更加真实和生动。该技术的挑战在于优化性能，确保在所有设备上的良好运行，因此对开发技能的要求也在逐步提升。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          物联网（IoT）的应用正在爆炸式增长，预计2024年将进一步扩大到智能家居、智能办公甚至智能城市建设领域。开发人员需要关注如何集成和安全管理大量从连接设备中获取的数据。随着5G网络的普及，物联网设备之间的连接速度和可靠性将得到显著提升，这也会为IoT发展带来更广阔的前景。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          随着数字化转型的深入，网络安全的重要性日益凸显。2024年，确保应用程序和数据的安全性将成为软件开发的首要任务。零信任架构（Zero
          Trust）正在成为一个新的安全框架，不再假设企业内外的网络是安全的，而是以更加细致的方式来保护数据和用户。这将激励安全方案的创新，从而帮助开发人员创建更为安全的应用程序。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          随着企业继续迁移到云端，云原生应用开发和微服务架构的转变对于提升软件项目的灵活性和可扩展性至关重要。2024年，开发人员将受到鼓励去构建能够跨多个云平台无缝运行的应用程序。这种方法通过将应用程序分解成更小、更可管理的模块，使其能更容易地更新和扩展，使业务能够快速响应市场变化。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          边缘计算通过将计算资源移到数据产生地附近，减少了数据的传输延迟，改善了应用程序性能。2024年，随着智能设备的激增和物联网的扩展，边缘计算的使用将变得更加广泛。开发者需要考虑如何高效地分配和管理边缘设备的资源，并确保数据的安全性。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          即时应用技术是指用户可以在无需下载和安装的情况下体验应用功能。从长远看，这种技术提高了用户的访问速度和体验满意度。2024年，更多的企业将开发即时应用，以增强用户体验和提高商业模式的灵活性，因此开发人员需要适应这种新兴的应用开发逻辑。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          开源软件在开发社区的流行并未减少，反而会继续增长。2024年，更多企业和开发者将加入开源项目的贡献行列，并将其作为促进创新和社区协作的关键因素。随着更多组织拥抱开源技术，企业对开发人员在开源项目参与度方面的期望也在增大，尤其是为了提升代码质量和安全性。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          随着环境问题的日益严重，绿色编码正受到越来越多的关注。软件开发者需要制定策略以减少其应用程序的碳足迹，优化代码和算法，以提高能源效率。2024年，绿色编码实践将成为主流，特别是在科技公司和追求可持续性发展的企业中。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          这些趋势不仅代表了技术的变化，更反映了整个软件开发行业对效率、创新和安全的日益重视。紧跟这些趋势，将有助于开发人员和企业在2024年及进一步未来中保持竞争力和创新力。
        </div>
      </div>


      <div v-if="num == 1" style="width: 90%;margin: 0 auto;padding-bottom: 3%;font-size: 2.4vw;">
        <div
          style="width: 100%;font-size: 5vw;border-bottom: 0.05em solid #ebecea;line-height: 1.5;margin-top: 3%;">
          马斯克大胆预测：2027年AI智力将反超人类
        </div>
        <!-- <div style="text-indent: 2em;line-height: 2;text-align: justify;margin-top: 3%;">
        原文：<a href="https://www.msn.cn/zh-cn/news/other/2024%E5%B9%B4%E8%BD%AF%E4%BB%B6%E4%B8%9A%E5%8D%81%E5%A4%A7%E8%B6%8B%E5%8A%BF%E5%89%8D%E7%9E%BB/ar-AA1vfcd4?ocid=BingNewsLanding&cvid=af5d2ffa729e460fee48b5b67184405a&ei=11#">2024年软件业十大趋势前瞻</a>
      </div> -->
        <div style="text-indent: 2em;line-height: 2;text-align: justify;margin-top: 3%;">
          埃隆·马斯克最近在社交媒体上发表了关于人工智能(AI)未来的大胆预言。马斯克指出，AI正以惊人的速度发展，而人类对这一变革的认知却显得相对迟缓。他大胆预言，在2025年底之前，AI的智力水平将超越任何单独的人类个体。到了2027年至2028年间，AI的整体智力或将凌驾于全人类之上。
        </div>
        <div style="width: 100%;text-align: center;margin-top: 2%;">
          <img style="width: 100%;" :src="require('../../public/img/news/image4.png')" alt="">
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          马斯克还强调，随着时间的推移，AI超越所有人类智力的趋势将愈发明显。他预计，到2030年，这一概率将逼近100%，标志着AI智力全面超越人类的新时代的到来。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          自chatGPT横空出世以来，全球资本对人工智能领域的热情空前高涨。据CB Insights数据显示，去年风投资本在人工智能初创公司上投入了高达425亿美元，涉及2500笔融资，彰显了资本对AI未来的坚定看好。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          然而，面对这一热潮，DeepMind的联合创始人兼CEO哈萨比斯(Demis Hassabis)却发出了警示。他认为，当前人工智能行业正呈现出类似于虚拟货币市场的泡沫迹象。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          尽管哈萨比斯同样认为通用人工智能(AGI)可能在未来十年内成为现实，但在此之前，仍需在一两个关键领域取得突破性进展。因此，他呼吁业界以更为科学、稳健的方法来推动AGI的构建与发展。
        </div>
      </div>


      <div v-if="num == 2" style="width: 90%;margin: 0 auto;padding-bottom: 3%;font-size: 2.4vw;">
        <div
          style="width: 100%;font-size: 5vw;border-bottom: 0.05em solid #ebecea;line-height: 1.5;margin-top: 3%;">
          “云+AI”赋能千行百业数智化转型升级
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;margin-top: 3%;">
          原文：<a
            href="https://www.msn.cn/zh-cn/news/other/%E4%BA%91-ai-%E8%B5%8B%E8%83%BD%E5%8D%83%E8%A1%8C%E7%99%BE%E4%B8%9A%E6%95%B0%E6%99%BA%E5%8C%96%E8%BD%AC%E5%9E%8B%E5%8D%87%E7%BA%A7/ar-AA1wxTQO?ocid=BingNewsLanding&cvid=af5d2ffa729e460fee48b5b67184405a&ei=25">“云+AI”赋能千行百业数智化转型升级</a>
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          在数字化时代，市场对云的需求进入到深度用云的阶段。尤其是伴随着人工智能的飞速发展，上云场景越来越复杂，需求越来越多样化，大量应用场景需要各专业协同去落地，共建生态是各行各业的诉求。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          12月18日，“全栈可信 云中生智”曙光云战略发布会召开。曙光云从首创“城市云”进化到实现“全栈智能云”，打造“云算、云数、云安、云智”四位一体能力体系，深度赋能千行百业数智化转型升级。
        </div>
        <div style="width: 100%;text-align: center;margin-top: 2%;">
          <img style="width: 95%;" :src="require('../../public/img/news/image5.png')" alt="">
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          曙光云副总裁孙会首表示，智能化是一个多维度的概念，站在不同的角度理解会有所不同。从供给侧来看，智能化意味着提供先进的技术解决方案，如选用合适的算力、构建大模型算法等。而作为运营方，曙光云不仅要提供技术平台，还要将智能化能力嵌入到客户的业务流程中，解决实际问题，提升业务效率。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          据悉，曙光云推出“多元算力融合底座”，提供多芯片算力服务，在通用云计算服务的基础上融合了更多人工智能计算的能力，全方位降低应用开发和应用智能化改造的难度。数据时代，数据来源愈加丰富，数据体量飞速增加，数据类型更加复杂多样，面对这些的挑战，曙光云推出全新升级的“轩辕可信数据平台”，具备数据全生命周期管理能力，打造安全的数据生产流水线，让数据可用不可见。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          曙光云总裁助理曾宇航介绍了曙光云提出的行业智能体架构：“这是一个综合解决方案，通过四位一体能力体系，实现端、边、云、用、数、模的融合，降低应用开发和智能化改造难度，深度赋能千行百业数字化转型。以煤炭矿山行业为例，曙光云通过构建三元融合算力体系，打通数据全链路，实现智能矿山的信息链打通，提升生产效率和安全性，展示了提供定制化智能解决方案的能力，推动行业的数智化转型。”
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          记者获悉，曙光云还聚焦能源、交通、政务等重点行业，提供更加精准和高效的智能化解决方案。在能源领域，曙光云将助力企业实现绿色、低碳、高效的运营。在交通领域，曙光云将推动智能交通系统的建设，提高交通管理的智能化水平。在政务领域，曙光云将助力政府提升治理效能和服务水平，打造智慧政务。
        </div>
      </div>

      <div v-if="num == 3" style="width: 90%;margin: 0 auto;padding-bottom: 3%;font-size: 2.4vw;">
        <div
          style="width: 100%;font-size: 5vw;border-bottom: 0.05em solid #ebecea;line-height: 1.5;margin-top: 3%;">
          Anthropic：2025年AI进化更剧烈，运算成本激增
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;margin-top: 3%;">
          原文：<a
            href="https://www.msn.cn/zh-cn/news/other/anthropic-2025%E5%B9%B4ai%E8%BF%9B%E5%8C%96%E6%9B%B4%E5%89%A7%E7%83%88-%E8%BF%90%E7%AE%97%E6%88%90%E6%9C%AC%E6%BF%80%E5%A2%9E/ar-AA1wvUk4?ocid=BingNewsLanding&cvid=f00331f237344ec8886a7bbfa81077d9&ei=11">Anthropic：2025年AI进化更剧烈，运算成本激增</a>
        </div>
        <div style="width: 100%;text-align: center;margin-top: 2%;">
          <img style="width: 95%;" :src="require('../../public/img/news/image6.png')" alt="">
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          背后有Google撑腰的AI创业公司商Anthropic共同创办人Jack Clark相信，OpenAI最近成功推出AI模型“o3”，暗示AI发展并未变慢，速度反倒加快了。不过，他警告，最新AI系统的运算成本是重大挑战。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          The Decoder 25日报道，Clark在自己的新闻报《Import
          AI》指出，“每个告诉你AI进展正在趋缓、扩张速度遇阻的人都错了”，OpenAI新推的o3模型就是增长还有空间的证据，但主要是得另辟蹊径。OpenAI并非单纯依靠规模更大的参数，而是让o3在执行时结合强化学习（reinforcement
          learning）技术，并导入额外算力。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          Clark指出，这种边思考边执行的方式，为拓展AI能力打开了全新可能性。他预测该趋势将于2025年加温，届时企业会开始在训练及推论过程中，将传统做法（例如参数更多的基础模型）结合全新的算力运用方式。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          Clark相信，AI演进速度太剧烈，许多人对此完全没准备。运算成本是重大挑战。o3最先进版本需要的算力，是基础版的170倍，而o3基础版使用的资源已比o1多，o1本身需要的算力也高于GPT-4o。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          Clark解释，这些最新系统让成本变得更加难以估算。在过去，成本主要是看模型的参数规模及输出长度，相当简单明了。然而，o3需要的资源却因任务的不同而有天壤之别。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          即便面临上述挑战，Clark依旧相信，把传统拓展方法跟新颖技术结合，将使AI在2025年更加急剧地演进，比至今为止的速度都还要快。
        </div>
      </div>

      <div v-if="num == 4" style="width: 90%;margin: 0 auto;padding-bottom: 3%;font-size: 2.4vw;">
        <div
          style="width: 100%;font-size: 5vw;border-bottom: 0.05em solid #ebecea;line-height: 1.5;margin-top: 3%;">
          不再“困”于宣传片，机器人从科幻走向现实
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;margin-top: 3%;">
          原文：<a
            href="https://www.msn.cn/zh-cn/news/other/%E4%B8%8D%E5%86%8D-%E5%9B%B0-%E4%BA%8E%E5%AE%A3%E4%BC%A0%E7%89%87%E9%87%8C-%E4%BA%BA%E5%BD%A2%E6%9C%BA%E5%99%A8%E4%BA%BA%E4%BB%8E%E7%A7%91%E5%B9%BB%E8%B5%B0%E5%90%91%E7%8E%B0%E5%AE%9E/ar-AA1wvWB1?ocid=BingNewsLanding&cvid=f00331f237344ec8886a7bbfa81077d9&ei=18">不再“困”于宣传片里，人形机器人从科幻走向现实</a>
        </div>
        <div style="width: 100%;text-align: center;margin-top: 2%;">
          <img style="width: 95%;" :src="require('../../public/img/news/image7.png')" alt="">
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          随着人工智能的跨越式发展，2024年，人形机器人逐渐从科幻走向现实，成为科技界的新热点。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          科技巨头纷纷布局、初创公司相继涌现、供应链不断完善、技术层层迭代……人形机器人作为人工智能领域最具代表性的实体，在大模型的催化下，正加速从实验室走向生产线，实现产业化落地。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          与2023年相比，今年的人形机器人市场，已经不再相信酷炫的宣传片和科技幻想故事，人形机器人的成本能降到多低？他们能用在哪里？成为市场最关切的话题。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          日前，美国《时代周刊》发表了封面文章，汇集并筛选了200项“2024年最佳发明”，其中，人形机器人登上封面，被称为2024年最伟大发明之一。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          目前，人形机器人一般可分为“本体”“小脑”和“大脑”三个部分。其中，“本体”是人形机器人的躯干和四肢；“大脑”承担类似人类大脑认知、推理和决策功能的功能，AI大模型的出现，让人形机器人能够更“聪明”地处理多模态的信息；“小脑”则负责运动控制与协调。相比其他机器人，人形机器人对智能感知、运动控制、智能决策、人机交互等综合能力要求更高。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          过去一年，英伟达、OpenAI、微软、特斯拉等国际领先科技巨头纷纷加码人形机器人赛道。与此前不同的是，人形机器人的发展不再局限于技术的突破，而是更加积极地探索商业化落地场景。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          日前，特斯拉发布了人形机器人Optimus-Gen2的最新视频。视频中，Optimus稳稳地接住了迎面抛来的网球并放下，反应速度与手部灵活度都有所提升。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          早在今年5月，特斯拉研发的二代Optimus人形机器人便已进厂实训，计划2025年底之前开始量产销售。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          11月6日，小鹏汽车发布了全新AI人形机器人Iron。据悉，Iron已经在小鹏的广州工厂初步实践，即将发布和交付的小鹏P7+部分生产岗位已由机器人操作。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          12月16日，上海智元新创技术有限公司（下称“智元机器人”）宣布，公司已开启通用机器人商用量产。据悉，智元机器人通用机器人年度计划产量为962台。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          在此之前，傅利叶、宇树科技、北京中科慧灵、四川天链机器人、魔法原子等企业也都宣布了有关机器人量产的消息。据悉，截至今年10月，傅利叶旗下通用人形机器人GR-1已量产交付超过100台。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          值得一提的是，今年以来，国内人形机器人赛道也备受资本关注。美团先后投资了银河通用、宇树科技；阿里巴巴也投资了逐际动力和星动纪元。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          据高工机器人产业研究所（GGII）不完全统计，今年1月份至10月份，全球人形机器人共发生69起融资事件，总金额超过110亿元。其中，有56起发生在国内，总金额超过50亿元。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          日前，初创企业开普勒机器人提及计划将人形机器人计划将价格控制约为2万—3万美元（折合人民币14万—21万元）左右。智元机器人预测，未来其首款人形机器人远征A1的制造成本将会被控制在20万元以内。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          “目前，人形机器人的商业化落地取得了一定成果，但距离大规模普及仍有距离。”在中国民协新质生产力委员会秘书长吴高斌看来，特斯拉、腾讯等企业已推出人形机器人产品，但成本高昂、技术成熟度不足等问题仍然存在。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          吴高斌认为，想要打通人形机器人商业化的“最后一公里”，关键在于通过技术创新和产业链整合，降低人形机器人的生产成本，使其更加亲民。同时，不断优化算法、传感器等关键技术，提高人形机器人的稳定性和可靠性。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          成本管控机制的完善，将大大降低终端售价，为大规模量产铺平道路。”支培元认为，2025年，人形机器人领域将迎来一系列重大突破。新材料的应用将进一步增强机械结构的灵活性与耐用性，推进人机界面的无缝衔接，使机器人更贴近人类行为模式。
        </div>
        <div style="text-indent: 2em;line-height: 2;text-align: justify;">
          “虽然确切时间表难以确定，但基于当前发展趋势，人形机器人渐趋平民化已成为不可逆转的趋势。预计在未来五至十年内，随着技术的日臻成熟与市场接受度的不断提高，个人及家庭拥有人形机器人的可能性将显著增加，进而带动社会生活方式的深刻变革。”支培元说。
        </div>
      </div>
    </div>

    <bottom></bottom>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        msglist: [
          {
            url: require('../../public/img/news/news0.png'),
            title: '进军中东通讯市场 中国电信沙特公司成立',
            content: '11月27日晚间，《每日经济新闻》记者从中国电信处获悉，近日，中国电信沙特公司在利雅得正式成立。中国电信沙特公司还与沙特电信公司（STC）、沙特华为公司及Baud Telecom Company分别举行了战略合作签约仪式。据中国电信介绍，上述公司的成立是中国电信深度服务共建“一带一路”，推动构建“中阿命运共同体”的重要里程碑。目前中国电信已于全球53个国家和地区设立分支机构，拥有52条国际海缆，27个自有IDC。'
          },
          {
            url: require('../../public/img/news/news1.png'),
            title: '第四大运营商诞生 为什么是中国广电？',
            content: '日前，中国广电获批成为我国第四大电信运营商。在中国移动、中国联通、中国电信三大运营商深耕市场十几年的背景下，为何让中国广电在此时入局？中国广电如何与三大传统运营商形成错位竞争？其参与5G发展，对于我国推进媒体融合将带来哪些积极影响？中国广电网络股份有限公司（以下简称“中国广电”）成为第四大电信运营商，这是推进全国有线电视网络整合和广电5G建设一体化发展迈出的重要一步。为何让中国广电在此时入局通信市场？中国广电如何与传统三大运营商形成错位竞争？'
          },
          {
            url: require('../../public/img/news/news4.png'),
            title: '运营商半年成绩单：“一家独大”与“三分天下”',
            content: '传统个人市场的“一家独大”与“第二曲线”市场的“三分天下。骄阳似火的7月，不仅是一年中最炎热的时节，也是三大运营商汇报半年发展成绩的时间。半年奋进，运营商的成绩几何？7月20日，随着中国电信、中国联通、中国移动6月运营数据的发布和工信部半年通信业经济运行情况的出炉，三大运营商上半年的用户发展成绩单也一并出炉。数据显示，上半年通信业整体运行平稳，网络连接用户规模持续扩大。特别是5G套餐用户首破12亿户，实现了历史性突破，赋能千行百业数字化转型的作用持续提升。'
          },
          {
            url: require('../../public/img/news/news6.png'),
            title: '中国联通半年数据：5G套餐用户达2.32亿户',
            content: '今日，中国联通发布6月运营数据。数据显示，中国联通6月“大联接”用户累计到达数为9.28亿户，较上月净增1004.6万户，半年累计增长0.66亿户；5G套餐用户累计到达数为2.32亿户，较上月净增281.9万户，半年累计增长0.19亿户；物联网终端连接累计到达数为4.43亿户，较上月净增1063万户，半年累计增长0.57亿户。中国联通5G行业虚拟专网服务客户数半年累计达5816个，较上月净增491个；授权专利半年累计数量1326件，较上月增419个。6月当月智慧客服问题解决率为97%，当月智慧客服智能服务占比达83.4%。'
          }
        ],

        num: 0,
      };
    },

    methods: {},

    mounted() {
      this.num = this.$route.query.num;
    },
  };
</script>

<style scoped>
  .w100 {
    width: 100%;
  }

  .minwidth {
    min-width: 1000px;
  }

  .positionrel {
    position: relative;
    overflow: hidden;
  }

  .pcScreen {
    display: block;
  }

  .mobileScreen {
    display: none;
  }

  @media screen and (max-width: 750px) {
    .pcScreen {
      display: none;
    }

    .mobileScreen {
      display: block;
    }

    .minwidth {
      min-width: 0px;
    }

    .mw100 {
      width: 100vw;
    }
  }
</style>